<h1 mat-dialog-title>{{ 'companies.detail.privacyDocsCard.studioSection.templatesDialog.title' | translate }}</h1>
<mat-dialog-content class="studio-privacy-templates-list">
  <div class="studio-privacy-template-row" *ngFor="let row of rows">
    <button
      mat-flat-button
      type="button"
      color="accent"
      class="studio-privacy-template-btn"
      [disabled]="row.loading"
      (click)="onDownload(row)">
      <mat-spinner *ngIf="row.loading" strokeWidth="2" [diameter]="16" class="d-inline-block"></mat-spinner>
      <ng-container *ngIf="!row.loading">
        <mat-icon fontSet="fal" fontIcon="fa-file-word"></mat-icon>
        {{ 'companies.detail.privacyDocsCard.studioSection.templatesDialog.download' | translate }}
      </ng-container>
    </button>
    <span class="studio-privacy-template-label">{{ row.labelKey | translate }}</span>
  </div>
</mat-dialog-content>
<div class="row" mat-dialog-actions>
  <div class="col-12 text-right">
    <button mat-raised-button (click)="onClose()">
      {{ 'common.cta.close' | translate }}
    </button>
  </div>
</div>
